import NiceModal from "@ebay/nice-modal-react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

export const AlertModal = NiceModal.create((props) => {
  const modal = NiceModal.useModal();

  const close = () => {
    modal.resolve();
    modal.hide();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={modal.visible}
      onClose={() => close()}
      TransitionProps={{onExited:()=> document.body.style.overflowY='auto'}}
    >
      {props.title && <DialogTitle className="!tw-text-2xl">{props.title}</DialogTitle>}

      <DialogContent>
        <Typography>{props.message}</Typography>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={() => close()}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
});

export function showAlertModal(props) {
  return NiceModal.show(AlertModal, props);
}
